module.exports = __webpack_public_path__ + "static/img/guanwang100.26ecd629.png";